import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class MergeReportAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'MergeReports';
  /**
   * Xử lý nhân bản một báo cáo mẫu merge
   * @param {*} payload Dữ liệu báo cáo cần nhân bản
   * @returns
   * npcuong 13.02.2023
   */
  async duplicateReport(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/DuplicateMergeReport',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new MergeReportAPI();
